import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Space, Typography, Badge, Avatar } from "antd";
import {
  MenuOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  MoonOutlined,
  SunOutlined,
} from "@ant-design/icons";
import CartDrawer from "../cart/CartDrawer";
import SignUpModal from "../pages/auth/SignUpModal";
import { logoutUser } from "../../redux/slices/authSlice";
import { menuItems } from "../../helpers/MenuList";
import { useLocation, useNavigate } from "react-router-dom";

const { Paragraph, Text } = Typography;
function HeaderSection({ screenWidth, toggleTheme, setOpen, darkMode }) {
  const [openCart, setOpenCart] = useState(false);
  const [openAuth, setOpenAuth] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.value);
  const navigate = useNavigate();
  const handleClose = () => {
    setOpenCart(false);
  };
  const cart = useSelector((state) => state.cart.value);
  return (
    <Paragraph
      size="small"
      style={{
        padding: "1rem 1.5rem",
        margin: 0,
        textAlign: "right",
        display: "flex",
        flexDirection: "row",
        justifyContent: "end",
        // alignContent: "center",
        alignItems: "center",
      }}
    >
      {screenWidth > 800 ? (
        <Paragraph className="link-container" style={{ margin: "0rem 1rem" }}>
          {menuItems.map((item) => (
            <Text
              onClick={() => navigate(item.path)}
              key={item.path}
              className="link-item"
              style={{
                color: item.path === location.pathname ? "#0abacc" : "",
              }}
            >
              {item.label}
            </Text>
          ))}
        </Paragraph>
      ) : (
        <MenuOutlined
          style={{
            padding: "1rem",
            fontSize: "22px",
            float: "left",
            left: 0,
            position: "absolute",
          }}
          onClick={() => setOpen(true)}
        />
      )}

      <Space size={10}>
        {user.name ? (
          <>
            {user?.name}
            <Text
              strong
              style={{ cursor: "pointer", color: "#0c6f8d" }}
              onClick={() => dispatch(logoutUser())}
            >
              Log Out
            </Text>
          </>
        ) : (
          <Text
            strong
            style={{ cursor: "pointer", color: "#0c6f8d" }}
            onClick={() => setOpenAuth(true)}
          >
            <Avatar icon={<UserOutlined />} size={25} />
          </Text>
        )}
        <Badge count={cart.length} size="small">
          <ShoppingCartOutlined
            style={{
              cursor: "pointer",
              fontSize: "20px",
            }}
            onClick={() => setOpenCart(true)}
          />
        </Badge>
        {darkMode ? (
          <SunOutlined
            onClick={toggleTheme}
            style={{ cursor: "pointer", fontSize: "20px" }}
          />
        ) : (
          <MoonOutlined
            onClick={toggleTheme}
            style={{ cursor: "pointer", fontSize: "20px" }}
          />
        )}
      </Space>

      {openAuth && (
        <SignUpModal openAuth={openAuth} setOpenAuth={setOpenAuth} />
      )}
      {openCart && <CartDrawer openCart={openCart} handleClose={handleClose} />}
    </Paragraph>
  );
}

export default HeaderSection;
